export const ui = {
    pictures: document.querySelector('.accordion-pictures') as HTMLElement,
    movies: document.querySelector('.accordion-movies') as HTMLElement
}
